import { useQuery } from '@tanstack/react-query';
import { IReferrer } from '@clickersphere/core/entities/IReferrer';
import ReferrerService from '@clickersphere/core/services/ReferrerService';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const REFERRERS_QUERY_KEY = 'referrers';

export type ReferrerQueryData = WithQueryStatus<IReferrer>;

export function useReferrers() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: referrers,
    isSuccess: isReferrersSuccess,
    isFetching: isReferrersFetching,
    isLoading: isReferrersLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(REFERRERS_QUERY_KEY),
    queryFn: async () => {
      const result = await ReferrerService.getAll();
      return result as ReferrerQueryData[];
    },
    select: (data) => [...data].sort((a, b) => a.name.localeCompare(b.name)),
  });

  return {
    referrers: referrers ?? [],
    isReferrersSuccess,
    isReferrersFetching,
    isReferrersLoading,
  };
}
